// Dropdown.js
import React, { useState, useRef, useEffect } from 'react';
import './css/DropDown.css';
import { url } from '../../constants/url';
import { toast } from 'react-toastify';
import { useAuth } from '../../Context/UserContext';

const Dropdown = ({ options = [], placeholder = 'Select', setOpenAssignDropdown, id, fetchVulnerabilityData }) => {
    const [isOpen, setIsOpen] = useState(false);
    const [selected, setSelected] = useState(null);
    const dropdownRef = useRef(null);

    const { userRole, userPermission } = useAuth()

    const handleSelect = async (option) => {
        setSelected(option);
        setIsOpen(false);
        await handleUpdateBugStatus(option);
    };

    const handleClickOutside = (e) => {
        if (dropdownRef.current && !dropdownRef.current.contains(e.target)) {
            setIsOpen(false);
        }
    };

    const handleUpdateBugStatus = async (bugStatus) => {
        try {
            const response = await fetch(`${url}/updatebugstatus`, {
                method: 'PUT',
                headers: {
                    "Content-Type": "application/json",
                },
                credentials: 'include',
                body: JSON.stringify({
                    vulnerabilityId: id,
                    bugStatus, // direct from param
                }),
            });

            if (response.status === 200) {
                fetchVulnerabilityData()
                setOpenAssignDropdown(false);
                toast.success("Bug status updated", {
                    position: "top-right",
                    autoClose: 2500,
                    pauseOnHover: false,
                });
            } else if (response.status === 400) {
                setOpenAssignDropdown(true);
                toast.error("Bad Request", {
                    position: "top-right",
                    autoClose: 2500,
                    pauseOnHover: false,
                });
            } else if (response.status === 440) {
                toast.error("User logout due to inactivity", {
                    position: 'top-right',
                    autoClose: 2500,
                    pauseOnHover: false,
                });
            }
        } catch (error) {
            console.error("Failed to update bug status:", error);
        }
    };

    useEffect(() => {
        document.addEventListener('mousedown', handleClickOutside);
        return () => document.removeEventListener('mousedown', handleClickOutside);
    }, []);

    return (
        <div className="dropdown-wrapper" ref={dropdownRef}>
            <div className="dropdown-header" onClick={() => setIsOpen(!isOpen)}>
                {selected || placeholder}
                <span className="dropdown-arrow">{isOpen ? '\u25B2' : '\u25BC'}</span>
            </div>

            {isOpen && (
                <ul className="dropdown-list">
                    {options.map((option, idx) => {

                        if (userPermission !== 'level 4' && (option === 'Open')) return null;

                        if (userPermission === 'level 4' && (option === 'Reopen' || option === 'Open')) return null;

                        return (
                            <li
                                key={idx}
                                className={`dropdown-item ${selected === option ? 'selected' : ''}`}
                                onClick={() => handleSelect(option)}>
                                {option}
                            </li>
                        );
                    })}
                </ul>
            )}

        </div>
    );
};


export default Dropdown;
